const Fade = {
  baseStyle: {
    width: "100%",
  },
};

export default Fade;
